import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'
import QRCode from 'react-qrcode-logo';
import generatePDF, { Resolution, Margin } from 'react-to-pdf';
import { FormattedMessage, injectIntl } from 'react-intl';

export const ConfigQRcode = injectIntl(class extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      images: [],
      loading: true,
      companyId: parseInt(this.props.match.params.companyId) || 0
    };
  }

  componentDidMount() {
    this.populateCompaniesData();
  }

  async addHeader(event) {
    var formData = new FormData();
    formData.append("file", event.target.files[0]);

    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/header`, {
      method: 'PUT',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      },
      body: formData
    });
    const data = await response.json();
    const images = this.state.images.filter(i => !i.includes("/header/"));
    images.push(data);
    this.setState(prevState => ({...prevState, images: images}));
  }

  async addFooter(event) {
    var formData = new FormData();
    formData.append("file", event.target.files[0]);

    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/footer`, {
      method: 'PUT',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      },
      body: formData
    });
    const data = await response.json();
    const images = this.state.images.filter(i => !i.includes("/footer/"));
    images.push(data);
    this.setState(prevState => ({...prevState, images: images}));
  }

  async removeHeader() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/header`, {
      method: 'DELETE',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      }
    });
    const data = await response.json();
    const images = this.state.images.filter(i => !i.includes("/header/"));
    this.setState(prevState => ({...prevState, images: images}));
  }

  async removeFooter() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/footer`, {
      method: 'DELETE',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      }
    });
    const data = await response.json();
    const images = this.state.images.filter(i => !i.includes("/footer/"));
    this.setState(prevState => ({...prevState, images: images}));
  }

  renderPrintTable() {
    const getTargetElement = () => document.getElementById('toprint');
    const options = {
      // default is `save`
      method: 'open',
      // default is Resolution.MEDIUM = 3, which should be enough, higher values
      // increases the image quality but also the size of the PDF, so be careful
      // using values higher than 10 when having multiple pages generated, it
      // might cause the page to crash or hang.
      resolution: Resolution.HIGH,
      page: {
          // margin is in MM, default is Margin.NONE = 0
          margin: Margin.SMALL,
          // default is 'letter'
          format: 'A4',
          // default is 'landscape'
          orientation: 'portrait',
      },
      canvas: {
          // default is 'image/jpeg' for better size performance
          mimeType: 'image/png',
          qualityRatio: 1
      },
      // Customize any value passed to the jsPDF instance and html2canvas
      // function. You probably will not need this and things can break, 
      // so use with caution.
      /*overrides: {
          // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
          pdf: {
            compress: true
          },
          // see https://html2canvas.hertzen.com/configuration for more options
          canvas: {
            useCORS: true
          }
      },*/
    };
    return (
      <>
        <div style={{marginTop: "10px"}}>
          <label for="header-upload" class="btn btn-primary">
            <i class="fa fa-cloud-upload"></i> <FormattedMessage id="upload_header"/>
          </label>
          <input id="header-upload" onChange={this.addHeader.bind(this)} type="file"/>
          {this.state.images.filter(i => i.includes("/header/")).length > 0 ? <div className="btndelhf" onClick={() => this.removeHeader()}>X</div> : <></>}
        </div>
      <div style={{border: "1px solid #ccc"}}><div id="toprint">
        {this.state.images.filter(i => i.includes("/header/")).length > 0 ? <div style={{marginBottom: "1rem", textAlign: "center"}}><img style={{maxWidth: "100%"}} src={this.state.images.filter(i => i.includes("/header/"))[0]}/></div> : <></>}
        <div style={{minHeight: "100px", contentAlign: "middle"}} class="main2 qrheaderdiv"><FormattedMessage id="you_author"/></div>
        <div class="qrheaderdiv main2"><FormattedMessage id="our_booking"/></div>
        <div class="qrdiv"><QRCode value={`https://www.planna.ru/booking/${this.state.companyId}`} size={330} qrStyle='fluid' logoPadding={10} removeQrCodeBehindLogo eyeRadius={15} ecLevel='H' logoImage='/plannasm.png' logoWidth={80} logoHeight={80}></QRCode></div>
        <div style={{marginTop: "15px", minHeight: "100px"}} class="main4 qrheaderdiv"><FormattedMessage id="your_time"/></div>
        {this.state.images.filter(i => i.includes("/footer/")).length > 0 ? <div style={{marginTop: "1rem", textAlign: "center"}}><img style={{maxWidth: "100%"}} src={this.state.images.filter(i => i.includes("/footer/"))[0]}/></div> : <></>}
      </div></div>

        <div class="tablediv">
          <label for="footer-upload" class="btn btn-primary">
            <i class="fa fa-cloud-upload"></i> <FormattedMessage id="upload_footer"/>
          </label>
          <input id="footer-upload" onChange={this.addFooter.bind(this)} type="file"/>
          {this.state.images.filter(i => i.includes("/footer/")).length > 0 ? <div className="btndelhf" onClick={() => this.removeFooter()}>X</div> : <></>}
        </div>

      <div style={{marginTop: "20px"}}>
        <label for="Button_Pdf"><FormattedMessage id="print_label"/> </label>
        <input style={{marginLeft: "5px"}} class="btn btn-primary" type="button" value={this.props.intl.formatMessage({id: "create_pdf"})} id="Button_Pdf" onClick={() => generatePDF(getTargetElement, options)}/>
      </div>
      </>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em><FormattedMessage id="loading"/></em></p>
      : this.renderPrintTable();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="qrcode" />
        <div class="headerdiv"><h4 id="tabelLabel"><FormattedMessage id="qr_code"/></h4></div>
        <div><FormattedMessage id="qr_page"/></div>
        {contents}
      </div>
    );
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
      const ownCompanies = this.state.companies.filter(c => this.state.companyId === 0 || c.id === this.state.companyId);
      if (ownCompanies.length > 0) {
        this.setState(prevState => ({...prevState, company: ownCompanies[0], companyId: ownCompanies[0].id}));
        this.populateImagesData(ownCompanies[0].id);
      } else {
        window.location.replace(`/configcompany/${this.state.companyId}`);
      }
    }
  }

  async populateImagesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/printimages`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, images: data, loading: false}));
  }
})